import { MatSnackBarConfig } from '@angular/material/snack-bar';

export const DEFAULT_SNACKBAR_DURATION: number = 2500;

export const MAT_SNACK_BAR_DEFAULT_CONFIG: MatSnackBarConfig = {
  verticalPosition: 'bottom',
  horizontalPosition: 'center',
  duration: DEFAULT_SNACKBAR_DURATION,
};
